import React, { Suspense } from "react"

import { LinearProgress } from "@material-ui/core"
const ClientSideOnlyLazy = React.lazy(() => import("../Home"))

const Main = () => {
  const isSSR = typeof window === "undefined"
  return (
    <>
      {!isSSR && (
        <Suspense
          fallback={
            <LinearProgress style={{ background: "rgba(30, 134, 255, 1)" }} />
          }
        >
          <ClientSideOnlyLazy />
        </Suspense>
      )}
    </>
  )
}

export default Main
